import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Plain window.scrollTo isn't enough here: Lenis (the smooth-scroll
    // library initialized in App.js) keeps its own internal scroll target
    // and re-applies it every animation frame, so a native scrollTo can get
    // overridden a frame later, especially right after a fast route change.
    // Resetting through Lenis itself keeps its internal state in sync.
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname]);

  return (
    <div className="min-h-screen bg-white text-navy font-sans antialiased">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
